// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeElement {
  margin-top: 200px;
  margin-bottom: 100px;
  padding-bottom: 200px;
  box-sizing: border-box;
  position: relative;
  clear: both; }

h2 {
  padding: 40px 40px 40px, 40px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 15px;
  margin-top: 40px;
  text-align: center; }

.particleEdit {
  background-color: #ffffff;
  opacity: 0.4; }

.typedClass {
  padding: 40px 40px 40px, 40px;
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  font-family: 'Poppins', sans-serif;
  top: 50%;
  float: right;
  left: 50%;
  font-size: 50px; }

.downArrow {
  position: absolute;
  width: 55px;
  left: 0;
  top: 0;
  font-size: 32px;
  line-height: 1;
  top: 78%;
  left: 50%;
  color: gray;
  opacity: 1; }

@media (max-width: 840px) {
  .downArrow {
    opacity: 0; }
  .typedClass {
    font-size: 30px; }
  #intro {
    font-size: 10px; } }

.downArrow:hover {
  color: black; }

#intro {
  font-family: 'Poppins', sans-serif;
  top: 45%;
  float: right;
  left: 50%;
  position: absolute; }
`, "",{"version":3,"sources":["webpack://./src/store/components/home/index.scss"],"names":[],"mappings":"AAEA;EACI,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW,EAAA;;AAIf;EACI,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,EAAA;;AAOtB;EACI,yBAAyB;EACzB,YAAY,EAAA;;AAEhB;EACI,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,eAAe,EAAA;;AAGnB;EACI,kBAAkB;EAClB,WAAW;EACd,OAAO;EACP,MAAM;EACN,eAAe;EACZ,cAAc;EACd,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU,EAAA;;AAGd;EACI;IACI,UAAU,EAAA;EAEd;IACI,eAAe,EAAA;EAEnB;IACI,eAAe,EAAA,EAClB;;AAIL;EACI,YAAY,EAAA;;AAGhB;EACI,kCAAkC;EAClC,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,kBAAkB,EAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');\n\n.homeElement {\n    margin-top: 200px;\n    margin-bottom: 100px;\n    padding-bottom: 200px;\n    box-sizing: border-box;\n    position: relative;\n    clear: both;\n    // flex: 1;\n}\n\nh2 {\n    padding: 40px 40px 40px, 40px;\n    margin-right: auto;\n    margin-left: auto;\n    margin-bottom: 15px;\n    margin-top: 40px;\n    text-align: center;\n}\n\n// .containerHome {\n//     // position: relative;\n// // }\n\n.particleEdit {\n    background-color: #ffffff;\n    opacity: 0.4;\n}\n.typedClass {\n    padding: 40px 40px 40px, 40px;\n    position: absolute;\n    margin-top: auto;\n    margin-bottom: auto;\n    font-family: 'Poppins', sans-serif;\n    top: 50%;\n    float: right;\n    left: 50%;\n    font-size: 50px;\n}\n\n.downArrow {\n    position: absolute;\n    width: 55px;\n\tleft: 0;\n\ttop: 0;\n\tfont-size: 32px;\n    line-height: 1;\n    top: 78%;\n    left: 50%;\n    color: gray;\n    opacity: 1;\n}\n\n@media (max-width: 840px) {\n    .downArrow {\n        opacity: 0;\n    }\n    .typedClass {\n        font-size: 30px;\n    }\n    #intro {\n        font-size: 10px;\n    }\n    \n}\n\n.downArrow:hover {\n    color: black;\n}\n\n#intro {\n    font-family: 'Poppins', sans-serif;\n    top: 45%;\n    float: right;\n    left: 50%;\n    position: absolute;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
